import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine'
import { InitCameraRatio, updateCamera, updateComparativeCamera } from 'Domain/Scene/Handler/CameraHandler'
import { rendererFormat } from 'Domain/Scene/Handler/RenderHandler'
import { getViewports, getViewportMode } from 'Domain/Scene/Handler/ViewportHandler'
import { GridUpdate } from '../../Mesh/Handler/Grid'
import { bigScale, defaultScale } from '../Builder/LabelBuilder'
import { composerRender } from 'Domain/Mesh/Handler/Composer'
import { updateAnimationState } from './AnimationManager'
import { updateOrbitControlCamera } from './ControlSyncManager'

export const adjustStrippingScaleForViewport = () => {
  const isMultiViewport = getViewportMode() !== 'single'

  const tempGroup = threeEngine.getTempGroup()
  if (!tempGroup) return
  tempGroup.children.forEach(obj => {
    if (obj.type === 'Line') return
    isMultiViewport ? bigScale(obj) : defaultScale(obj)
  })
}

export const adjustMarkupScaleForViewport = () => {
  const viewportMode = getViewportMode()
  const marks = threeEngine.getMarks()
  if (!marks) return

  let factor = 1
  if (viewportMode === 'double') factor = 1.5
  else if (viewportMode === 'triple') factor = 2

  marks.traverse(obj => {
    if (obj.type === 'Line') return
    if (!obj.userData?.baseScale || !obj.scale) return
    obj.scale.set(obj.userData.baseScale * factor, obj.userData.baseScale * factor, obj.userData.baseScale * factor)
  })
}

const setupViewport = (renderer, viewportIndex, viewportWidth, viewportHeight) => {
  const xPosition = Math.floor(viewportWidth * viewportIndex)
  rendererFormat(renderer, xPosition, 0, viewportWidth, viewportHeight)
}

const setupCamera = (viewportName, viewportWidth, viewportHeight) => {
  const camera = threeEngine.getCamera(viewportName)
  if (!camera) return null
  updateCamera(camera, threeEngine.getControls(), threeEngine.getCenter())
  InitCameraRatio(viewportWidth, viewportHeight, camera)
  return camera
}

const renderViewport = (scene, renderer, camera, viewportWidth, viewportHeight) => {
  renderer.clear()
  GridUpdate(scene, camera)
  updateComparativeCamera()
  composerRender(scene, camera, viewportWidth, viewportHeight)
}

export const renderAllViewports = (scene, renderer, canvasWidth, canvasHeight) => {
  const viewports = getViewports()
  const viewportWidth = Math.floor(canvasWidth / viewports.length)
  const viewportHeight = Math.floor(canvasHeight)

  viewports.forEach((viewport, index) => {
    setupViewport(renderer, index, viewportWidth, viewportHeight)
    const camera = setupCamera(viewport.name, viewportWidth, viewportHeight)
    if (!camera) return
    updateAnimationState(camera)
    renderViewport(scene, renderer, camera, viewportWidth, viewportHeight)
  })

  updateOrbitControlCamera()
}
